module.exports = __webpack_public_path__ + "static/media/top-brand-55.2d3263d5.png";